module.exports = __webpack_public_path__ + "img/github.0384a95.svg";